export default color => color.indexOf('#') === 0;
